import React from 'react';

/**
 * 队员状态分区标题
 */
export default function DashboardMemberStatusTitle({ variant = 'desktop' }) {
  const isMobile = variant === 'mobile';
  return (
    <div style={isMobile ? {
      fontSize: 14,
      fontWeight: 600,
      color: '#1976d2',
      marginBottom: 8,
      padding: '6px 8px',
      borderBottom: '2px solid #1976d2',
      background: '#fff',
      flexShrink: 0
    } : {
      fontSize: 16,
      fontWeight: 600,
      color: '#1976d2',
      marginBottom: 12,
      padding: '8px 0',
      borderBottom: '2px solid #1976d2'
    }}>
      队员状态
    </div>
  );
}
